
import React from 'react';

import './Terminal.css'
import {Well} from "react-bootstrap";


export default class AltiomTerminal extends React.Component {

  constructor(props){
     super(props);
     //this.escFunction = this.escFunction.bind(this);
     this.state = {
       input:"hello",
       shellinput:"",
       history:[],
       history_index:-1,
     }

   }

   scrollToBottom = () => {
     this.messagesEnd.scrollIntoView({ behavior: "auto" });
   }

   componentDidMount() {
     this.scrollToBottom();
   }
   componentDidUpdate() {
     this.scrollToBottom();
   }

   onKeyPressed=(e)=> {
     console.log(e)
    console.log(e.keyCode);
    console.log(e.ctrlKey)
  //this.refs.messages.scrollTop =

    if(e.ctrlKey==true && e.keyCode==67){
      //its ctrl C
      //Send this through!!!!
      console.log("Send Ctrl C")
      let code="\u0003"
      let d={
        "cmd":"shell",
        "interupt":true
      }
      this.props.callback(d)
    }

    if(e.keyCode==38){ //UP
      console.log("UP")
      console.log(this.state.history_index)
      //go through history
      if(this.state.history_index==-1){
        let index=this.state.history.length-1
        console.log(index)
        if(index!=-1){ //we have more than one item in history
          this.setState({shellinput:this.state.history[index]})
        }
        this.setState({history_index:index})
      }else{
          let index=this.state.history_index
          if(index>0){
            index=index-1
          }
          this.setState({shellinput:this.state.history[index]})



          this.setState({history_index:index})
      }

    }
    if(e.keyCode==40){ //DOWN
      if(this.state.history_index!=-1){
      let index=this.state.history_index

        if(index<this.state.history.length-1){
          index=index+1
          this.setState({shellinput:this.state.history[index]})
          this.setState({history_index:index})
        }

      }

    }

    if(e.keyCode==13){
      console.log("Send the command")
      //let history=this.state.history

      let history=new Set(this.state.history)

      history.delete(this.state.shellinput)
      history.add(this.state.shellinput)
      //temp=this.state.shellinput
      history = Array.from(history);
      this.setState({history:history})
      this.setState({history_index:-1})


      let d={
        "cmd":"shell",
        "tx":this.state.shellinput
      }
      this.props.callback(d)
      this.setState({shellinput:""})

      console.log(history)
    }


  }
  inputChange=(e)=>{
    console.log("Change?")
    this.setState({shellinput:e.target.value})

  }


  render(){

    return (
      <Well className="shell">
      <div className="shelldata" refs="messages">
        {this.props.data}
        <div style={{ float:"left", clear: "both" }}
             ref={(el) => { this.messagesEnd = el; }}><span></span>
        </div>
      </div>
      <div>
      <input className="shellinput"  onKeyDown={this.onKeyPressed} value={this.state.shellinput} onChange={this.inputChange}></input>
      </div>
      </Well>
    )


  }

}



// WEBPACK FOOTER //
// ./src/programmerComponents/AltiomTerminal.js